import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IStation } from '../interfaces/station.interface';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StationService {

  private urlApi: String = environment.urlApi;

  constructor(
    private _httpClient: HttpClient
  ) { }

  getStation(id: string){
    return this._httpClient.get<IStation>(`${this.urlApi}/public/station/id/${id}`).pipe(
      catchError(e => {
        return throwError(e)
      })
    )
  }
}
